import React, { memo, useCallback } from "react";
import { Video } from "../../../../common/video/models/Video";
import stylesPc from "./ContentCard.module.css";
import stylesSp from "./ContentCard_SP.module.css";
import { Link, useHistory } from "react-router-dom";
// import { VideoTag } from "../../../../common/video/models/VideoTag";
// import Tag from "../../../../common/components/tag/Tag";
// import { SpacedList, SpacedListItem } from "../../../../common/components/spacedList/SpacedList";
import VideoPresenter from "../../../../common/components/video/presenter/VideoPresenter";
import VideoMenu from "../../../../common/components/videoMenu/VideoMenu";
import EditVideoPage from "../../../../common/components/videoMenu/EditVideo";
import LinearProgress from "@material-ui/core/LinearProgress";
import PuiTooltip from "../../../../components/elements/PuiTooltip ";
import PuiTypography from "../../../../components/elements/PuiTypography";
import { createStyles, makeStyles } from "@material-ui/core";
import EditSlideStock from "../../../videoPlayer/components/slideStockEdit/EditSlideStock";
import { useInitFlag } from "../../../../components/function/useInitFlag";
import { IsDevice } from "../../../../components/function/useDeviceFlag";

interface ContentCardProps {
    content: any;
    setMsg: (msg: string) => void;
}

const useStyles = makeStyles(() =>
    createStyles({
        barColorPrimary: {
            backgroundColor: "var(--studio-btn-bg)",
        },
    })
);

function ContentCard({ content, setMsg }: ContentCardProps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;
    const classes = useStyles();
    const history = useHistory();
    const [isShowMenu, setShowMenu] = useInitFlag();

    // 視聴履歴の進捗インジケータを計算
    const normalise = (content: Video) => {
        if (!content.viewingActivities || content.viewingActivities.length === 0) {
            return 0;
        } else {
            const progressMillis = content.viewingActivities[0].progressMillis;
            const isFinished = content.viewingActivities[0].isFinished;
            if (progressMillis !== null) {
                const rate = Math.floor(
                    (Number(progressMillis) / Number(content.durationMillis)) * 100
                );

                return rate;
            } else if (progressMillis === null && isFinished) {
                return 100;
            }
        }
    };

    // const avater = avaterStyles();
    // ビデオ詳細画面遷移
    const goToVideo = useCallback(() => history.push(`/video/${content.id}`), [content, history]);

    // コンテンツ詳細画面遷移
    const goToContent = useCallback(
        () => history.push(`/slidestock/${content.id}`),
        [content, history]
    );

    return (
        <div className={styles.card}>
            <div className={styles.thumbnaildiv}>
                {/* ビデオ情報表示 */}
                {!content.fileType && (
                    <img
                        className={styles.thumbnail}
                        src={content.imageUrl}
                        alt=""
                        onClick={goToVideo}
                        onError={(e) =>
                            (e.currentTarget.src = require("../../../../assets/image/NoImage.jpg"))
                        }
                    />
                )}

                {/* スライド情報 */}
                {content.fileType && (
                    <img
                        className={styles.thumbnail}
                        src={content.imageUrl}
                        alt=""
                        onClick={goToContent}
                        onError={(e) =>
                            (e.currentTarget.src = require("../../../../assets/image/NoImage.jpg"))
                        }
                    />
                )}
                <div className={isShowMenu ? styles.showMenu : styles.videoMenu}>
                    {!content.fileType && (
                        <VideoMenu
                            videoId={content.id}
                            setMsg={setMsg}
                            setIsShowing={setShowMenu}
                        />
                    )}
                </div>
                {/* ビデオ編集ボタン */}
                {!content.fileType && (
                    <div className={styles.editVideoIcon}>
                        <EditVideoPage videoId={content.id} />
                    </div>
                )}

                {/* コンテンツ編集ボタン表示 */}
                {content.fileType && (
                    <div className={styles.editVideoIcon}>
                        <EditSlideStock slideId={content.id} />
                    </div>
                )}
                {/* 新規ビデオアイコン */}
                {content.visibleNewIcon && (
                    <img
                        src={require("../../../../assets/image/newIcon.svg")}
                        className={styles.newIcon}
                        alt={`newIcon_${content.id}`}
                    />
                )}
            </div>
            <LinearProgress
                className={styles.progressBar}
                classes={{ barColorPrimary: classes.barColorPrimary }}
                style={{ height: "2px" }}
                variant="determinate"
                value={normalise(content)}
            />
            {/* <div className={styles.text} onClick={goToVideo}> */}
            <div className={styles.text}>
                <Link to={`/video/${content.id}`}>
                    <div className={styles.cardTitle} data-for="listtitle" data-tip={content.title}>
                        <PuiTypography size="videoTitle" bold={true}>
                            {content.title}
                        </PuiTypography>
                    </div>
                    <PuiTooltip id="listtitle" />
                </Link>
                <VideoPresenter presenter={content.presenter} content={content} />
                <div
                    className={styles.cardTags}
                    style={{
                        display: content.tags.length > 0 ? "flex" : "none",
                        height: content.tags.length === 0 ? "0" : "",
                    }}
                >
                    {/* ビデオ */}
                    {/* {!content.fileType && content.tags.length > 0 && (
                        <SpacedList>
                            {content.tags.map((tag: VideoTag) => (
                                <SpacedListItem key={tag}>
                                    <Tag tag={tag} />
                                </SpacedListItem>
                            ))}
                        </SpacedList>
                    )} */}

                    {/* スライド */}
                    {/* {content.fileType && content.tags.length > 0 && (
                        <SpacedList>
                            {content.tags.map(
                                (tag: string, index: React.Key | null | undefined) => (
                                    <SpacedListItem key={index}>
                                        <Tag contentTag={tag} />
                                    </SpacedListItem>
                                )
                            )}
                        </SpacedList>
                    )} */}
                </div>
            </div>
        </div>
    );
}

export default memo(ContentCard);
